import * as React from "react";
import {useState, useRef, createRef} from "react";
import {imageBaseUrl} from "config";
import "./styles.scss";
import {COLOR} from "utils/variables";
import jsPDF from "jspdf";
import Button from "myshubhlife-component/button";
import SelectField from "myshubhlife-component/selectField";
import CSS from "csstype";
import { compressImage } from "utils/imageConversion";

export enum DocUploadSide {
   FRONT = "FRONT",
   BACK = "BACK",
}

interface  IDocTypeOptions {
    name: string;
    value: string;
}
export enum FileType {
    JPG = "image/jpg",
    JPEG = "image/jpeg",
    PNG = "image/png",
    PDF = "application/pdf",
}
interface IProps {
   fileName: string;
   primaryLabel: string;
   uploadSide: string[];
   getPdfBase64: (bs64, docType, docSubType: string) => void;
   secondaryLabel?: string;
   errorMsg?: string;
   backgroundColor?: string;
   acceptType?: string;
   docOptions?: IDocTypeOptions[];
   isUploaded?: boolean;
   compressionRequired?: boolean;
}

interface IConvertImageToPdf {
    bs64: string;
    fileType: string;
}

const getBase64 = (event, fileSelected, uploadSide: string, compressReq: boolean) => {
    const files = event.target.files;
    if (files.length > 0) {
        const fr = new FileReader();
        if (compressReq && files[0].type.includes("image")) {
            const compressedFile: Promise<File> = compressImage(files[0]);
            compressedFile.then((data) => {
                fr.onload = (evt) => {
                    const b64 = window.btoa((evt.target as any).result);
                    fileSelected(files, uploadSide, b64);
                };
                fr.readAsBinaryString(data);
            });
        } else {
            fr.onload = (evt) => {
                const b64 = window.btoa((evt.target as any).result);
                fileSelected(files, uploadSide, b64);
            };
            fr.readAsBinaryString(files[0]);
        }
    }
};

export const convertPdfFromImages = (imgObj: IConvertImageToPdf[], title: string) => {
    let bs64Pdf;
    const doc = new jsPDF("p", "mm", "a4");
    if (imgObj && imgObj.length > 0) {
        imgObj.forEach((item) => {
            if (title) {
                doc.text(title, 20, 20);
            }
            doc.addPage();
            doc.addImage(
                item.bs64,
                item.fileType,
                15, 40, 180, 160,
              );
        });
        doc.deletePage(1);
        const result = doc.output();
        bs64Pdf = btoa(result);
    }
    return bs64Pdf;
   };

const MultiDocUpload = (props: IProps) => {
   const fileInputRef: any = useRef(props.uploadSide.map(() => createRef()));
   const [file, setSelectedFile] = useState(null);
   const [uploadDocType, updateUploadDocType] = useState(null);
   const [errors, setErrors] = useState(null);
   const style: CSS.Properties = {
       height: "47px",
       backgroundColor: props.backgroundColor ? props.backgroundColor : COLOR.PURPLE,
       width: "100%",
       color: COLOR.WHITE,
       margin: "5px 0px",
       borderRadius: "5px",
   };
   const containerStyle: CSS.Properties = {
       marginBottom: "10px",
   };
   const secondaryLabelStyle: CSS.Properties = {
        fontSize: "14px",
        paddingLeft: "2px",
    };
   const errorStyle: CSS.Properties = {
        textAlign: "center",
        fontSize: "14px",
        color: COLOR.RED,
        marginTop: "10px",

    };
   const updateFileState = (files, uploadSide, bs64) => {
        if (errors) {
            setErrors(null);
        }
        setSelectedFile((oldState: any) => {
           return{
               ...oldState,
               [uploadSide]: {file: files[0], bs64},
           };
       });
   };
   const docTypeSelectHandler = (fileName, value) => {
    if (errors) {
        setErrors(null);
    }
    updateUploadDocType(value ? value : null);
   };

   const handleMergeAndUpload = (files, docType) => {
    const arrayOfObj = [];
    if (!files || (Object.keys(files).length !== props.uploadSide.length)) {
        return setErrors("Please select both images");
    } else if (props.docOptions && !uploadDocType) {
        return setErrors("Please select type");
    } else {
        for (const img in files) {
            if (files[img].file.type === FileType.JPEG ||
            files[img].file.type === FileType.JPG ||
            files[img].file.type === FileType.PNG) {
                arrayOfObj.push({
                    bs64: files[img].bs64,
                    fileType: files[img].file.type,
                });
            } else {
                return setErrors("Only image(.jpg, .png) files allowed!");
            }
        }
    }
    updateUploadDocType(null);
    props.getPdfBase64(convertPdfFromImages(arrayOfObj, docType), props.fileName, uploadDocType);
   };
   return (
       <div className="multi-doc-container">
           <div className="label-container">
                <label className="heading">
                    {props.primaryLabel}
                </label>
                {
                    props.isUploaded &&
                    <img style={{float: "right", marginRight: "61px"}}
                    src={`${imageBaseUrl}/img/icons/green_tick.png`} alt="selected"/>
                }
           </div>
           <hr style={{marginTop: 0}}/>
           {
               props.docOptions &&
               <SelectField
                    options={props.docOptions}
                    fieldName={"docName"}
                    onChangeHandler={docTypeSelectHandler}
                    styleType={"line"}
                />
           }
           {errors &&
               <small style={{color: COLOR.RED, paddingLeft: 2}}>
                   {errors}
               </small>
           }
           {
               uploadDocType &&
               <div style={containerStyle}>
                {
                props.secondaryLabel &&
                    <div style={secondaryLabelStyle}>
                        {props.secondaryLabel}
                    </div>
                }
               {
                   props.uploadSide.length > 0 && props.uploadSide.map((uploadSide , index) => {
                   return(
                   <div style={style}
                        key={index}
                        onClick={() => fileInputRef.current.map((ref) => {
                            if (ref.current.id === uploadSide) {
                                ref.current.click();
                            }
                        })}
                   >
                       <input
                           ref={fileInputRef.current[index]}
                           type="file"
                           id={uploadSide}
                           style={{display: "none"}}
                           onChange={(e) => getBase64(e, updateFileState, e.target.id, props.compressionRequired)}
                           accept={props.acceptType}/>
                       <div className="doc-input-container">
                           <div className="left-container">
                               {!file || !file.hasOwnProperty(uploadSide) ?
                                   <div className="label-container">
                                       <div className="primary-label">
                                           {uploadSide}
                                       </div>
                                   </div>
                                   :
                                   <div className="file-selected-container">
                                       <div className="tick-icon">
                                           <img src={`${imageBaseUrl}/img/icons/green_tick.png`} alt="selected"/>
                                       </div>
                                       <div className="selected-text">
                                           {file.hasOwnProperty(uploadSide) && file[uploadSide].file.name.slice(0, 25)}
                                       </div>
                                   </div>
                               }
                           </div>
                           <div className="right-container">
                               <img src={`${imageBaseUrl}/img/icons/upload_icon.png`} alt="upload"/>
                           </div>
                       </div>
                   </div>
                   );
               })
           }
           <span style={{fontSize: 12, paddingLeft: 2}}>* Ensure you are uploading only image files</span>
            <Button
                buttonText={"Merge & Upload"}
                onClick={() => handleMergeAndUpload(file, uploadDocType)}
                width={"150px"}
                height={33}
                isDisabled={!file || (Object.keys(file).length !== props.uploadSide.length)}
                />
           </div>
        }
       {
           props.errorMsg &&
           <div style={errorStyle}>
               {props.errorMsg}
           </div>
       }
       </div>
   );
};

MultiDocUpload.defaultProps = {
 acceptType: "image/*",
};
export default MultiDocUpload;
